export const GetUsersRequestedFields = [
  "id",
  "user_id",
  "school_id",
  "external_id",
  "group",
  "firstname",
  "lastname",
  "patronymic",
  "username",
  "email",
  "phone",
  "photo",
  "color",
  "description",
  "is_need_complete_challenge",
  "is_online",
  "student",
];

export const GetStudentsAsManagerFullInfoRequestedFields = [
  "id",
  "user_id",
  "user:id",
  "user:school_id",
  "user:external_id",
  "user:group",
  "user:firstname",
  "user:lastname",
  "user:patronymic",
  "user:username",
  "user:email",
  "user:phone",
  "user:photo",
  "user:photo_thumb",
  "user:color",
  "user:description",
  "user:is_need_complete_challenge",
  "user:is_online",
];
